import { PolicyCheck } from '@/features/auth/authorization';
import { AssetPolicies } from './assets';
import { BlackoutPolicies } from './blackouts';
import { DepotPolicies } from './depots';
import { GeneratorPolicies } from './generators';
import { MaintenancePolicies } from './maintenance';
import { VehiclePolicies } from './vehicles';
import { WorkOrderPolicies } from './work-orders';

export const EquipmentPolicies: Record<string, PolicyCheck> = {
  'equipment.view': ({ acl, user, meta }) => {
    return acl.equipment.view;
  },
  ...AssetPolicies,
  ...VehiclePolicies,
  ...GeneratorPolicies,
  ...DepotPolicies,
  ...BlackoutPolicies,
  ...MaintenancePolicies,
  ...WorkOrderPolicies,
};
